<template>
  <el-dialog
    :close-on-click-modal="false"
    title="新增交易用途"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="420px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="chooseVehicle" slot-scope="prop" class>
          <ChooseVehicle
            style="display: inline-block"
            :isRadio="true"
            v-model="prop.form.chooseVehicle"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  // oilDetail,
  doQueryParent,
  saveOrUpdateOilCard,
} from 'api/service';
import {
  getEnumList,
} from 'api';
import ChooseVehicle from 'components/choose/vehicle';
import {addTransactionPurpose} from 'api/getPay';
export default {
  components: {
    ChooseVehicle,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      formData: {
        cardTypeOptions: [],
        parentCardIdOptions: [],
        oilCardStatusOptions: [],
        form: [
          {
            label: '交易用途',
            value: 'codeName',
            type: 'input',
          },
        ],
        rules: {
          codeName: [ // 交易用途
            { required: true, message: '请输入交易用途', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      form.codeType = 'TRANSACTION_PURPOSE';
      const res = await addTransactionPurpose(form);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
